import request from '@/utils/request'

// 查询商城头条分页
export function pageHeadline(data) {
  return request({
    url: '/news/headline/page',
    method: 'post',
    data: data
  })
}

// 查询商城头条列表
export function listHeadline(query) {
  return request({
    url: '/news/headline/list',
    method: 'get',
    params: query
  })
}

// 查询商城头条详情
export function getHeadline(data) {
  return request({
    url: '/news/headline/detail',
    method: 'get',
    params: data
  })
}

// 新增商城头条
export function addHeadline(data) {
  return request({
    url: '/news/headline/add',
    method: 'post',
    data: data
  })
}

// 修改商城头条
export function updateHeadline(data) {
  return request({
    url: '/news/headline/edit',
    method: 'post',
    data: data
  })
}

// 删除商城头条
export function delHeadline(data) {
  return request({
    url: '/news/headline/delete',
    method: 'post',
    data: data
  })
}

// 导出商城头条
export function exportHeadline(data) {
  return request({
    url: '/news/headline/export',
    method: 'post',
    data: data
  })
}
